import React, { useState, useEffect } from 'react';
import { useLocalization } from '../../utils/hooks/useLocalization'
import { ChevronDown, ShoppingBag } from 'lucide-react';
import { ReactComponent as LogoExtended } from '../../assets/logo-extended.svg';
import styles from './HeroSection.module.css';

const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const { t } = useLocalization();
  const [shapesLines, setShapesLines] = useState(
    Array.from({ length: 5 },
      () => Array.from({ length: 4 }, () => Math.random())
    )
  );
  const [shapesDots, setShapesDots] = useState(
    Array.from({ length: 5 },
      () => Array.from({ length: 4 }, () => Math.random())
    )
  );

  useEffect(() => {
    setIsLoaded(true);
    
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToProducts = () => {
    document.getElementById('products').scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <section className={styles.hero}>
      {/* Parallax Background */}
      <div 
        className={styles.parallaxBg}
        style={{ transform: `translateY(${scrollY * 0.5}px)` }}
      >
        <div className={styles.gradientOverlay}></div>
        <div className={styles.animatedLines}>
          {shapesLines.map((lineState, i) => (
            <div
              key={i}
              className={`${styles.line} ${isLoaded ? styles.animate : ''}`}
              style={{
                left: `${lineState[0] * 100}%`,
                height: `${lineState[1] * 40 + 20}%`,
                animationDelay: `${lineState[2] * 3}s`,
                animationDuration: `${lineState[3] * 2 + 3}s`
              }}
            />
          ))}
        </div>
        
        {/* Floating geometric shapes for parallax effect */}
        <div className={styles.floatingShapes}>
          {shapesDots.map((dotState, i) => (
            <div
              key={i}
              className={styles.shape}
              style={{
                left: `${dotState[0] * 100}%`,
                top: `${dotState[1] * 100}%`,
                transform: `translateY(${scrollY * (0.1 + dotState[2] * 0.2)}px) rotate(${scrollY * 0.1}deg)`,
                animationDelay: `${dotState[3] * 2}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Hero Content */}
      <div className={styles.content}>
        <div className={`${styles.textContent} ${isLoaded ? styles.loaded : ''}`}>
          <div className={styles.title}>
            <LogoExtended />
          </div>
          
          <h3 className={styles.subtitle}>
            {t("landing_heroCaption1") + " " + t("landing_heroCaption2")}
            {/* <span className={styles.highlight}></span> */}
          </h3>

          <div className={styles.buttonGroup}>
            <button onClick={scrollToProducts} className={styles.primaryBtn}>
              <ShoppingBag size={20} />
              {t("discover")}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={styles.scrollIndicator} onClick={scrollToProducts}>
        <ChevronDown size={32} />
      </div>
    </section>
  );
};

export default HeroSection;
